// extracted by mini-css-extract-plugin
export default {"svg":"ModalInfo_svg__T-Fld"};